import { render, staticRenderFns } from "./ConfigureSettingsNew.vue?vue&type=template&id=d2954712&scoped=true"
import script from "./ConfigureSettingsNew.vue?vue&type=script&lang=js"
export * from "./ConfigureSettingsNew.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettingsNew.vue?vue&type=style&index=0&id=d2954712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2954712",
  null
  
)

export default component.exports